import api from './axios'

/**
 * Link trainer to team
 * @param {number} trainerId 
 * @param {number} teamId 
 * @returns {Promise<object>}
 */
export const linkTrainerTeam = async (trainerId, teamId) => {
  const response = await api.post('/links/trainer-team', {
    trainer_id: trainerId,
    team_id: teamId
  })
  return response.data
}

/**
 * Unlink trainer from team
 * @param {number} trainerId 
 * @param {number} teamId 
 * @returns {Promise<object>}
 */
export const unlinkTrainerTeam = async (trainerId, teamId) => {
  const response = await api.delete('/links/trainer-team', {
    data: {
      trainer_id: trainerId,
      team_id: teamId
    }
  })
  return response.data
}

/**
 * Link trainer to contract
 * @param {number} trainerId 
 * @param {number} contractId 
 * @param {boolean} sendEmail - Whether to send signing link email
 * @returns {Promise<object>}
 */
export const linkTrainerContract = async (trainerId, contractId, sendEmail = false) => {
  const response = await api.post('/links/trainer-contract', {
    trainer_id: trainerId,
    contract_id: contractId,
    send_email: sendEmail
  })
  return response.data
}

/**
 * Unlink trainer from contract
 * @param {number} trainerId 
 * @param {number} contractId 
 * @returns {Promise<object>}
 */
export const unlinkTrainerContract = async (trainerId, contractId) => {
  const response = await api.delete('/links/trainer-contract', {
    data: {
      trainer_id: trainerId,
      contract_id: contractId
    }
  })
  return response.data
}

/**
 * Link team to contract
 * @param {number} teamId
 * @param {number} contractId
 * @returns {Promise<object>}
 */
export const linkTeamContract = async (teamId, contractId) => {
  const response = await api.post('/links/team-contract', {
    team_id: teamId,
    contract_id: contractId
  })
  return response.data
}

/**
 * Unlink team from contract
 * @param {number} teamId
 * @param {number} contractId
 * @returns {Promise<object>}
 */
export const unlinkTeamContract = async (teamId, contractId) => {
  const response = await api.delete('/links/team-contract', {
    data: {
      team_id: teamId,
      contract_id: contractId
    }
  })
  return response.data
}

/**
 * Send contract email (signing link or reminder)
 * @param {number} trainerId
 * @param {number} contractId
 * @param {string} type - 'signing_link' or 'reminder'
 * @returns {Promise<object>}
 */
export const sendContractEmail = async (trainerId, contractId, type = 'signing_link') => {
  const response = await api.post('/links/send-contract-email', {
    trainer_id: trainerId,
    contract_id: contractId,
    type
  })
  return response.data
}